import { render, staticRenderFns } from "./DayTypeCalendarEditor.vue?vue&type=template&id=588487b8"
import script from "./DayTypeCalendarEditor.vue?vue&type=script&lang=js"
export * from "./DayTypeCalendarEditor.vue?vue&type=script&lang=js"
import style0 from "./DayTypeCalendarEditor.vue?vue&type=style&index=0&id=588487b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports